const el = `scroll-spy`;
const menuEl = `scroll-spy-menu`;
const isMobileDisplay = () => window.innerWidth <= 1800;

const getStickyMenuOffset = () => document.querySelector(`.${menuEl}`).clientHeight;

function isElementScrolledPast(el) {
  const rect = el.getBoundingClientRect();
  const headerHeight = isMobileDisplay() ? getStickyMenuOffset() : 0;
  return rect.top >= 0 && window.scrollY + headerHeight >= rect.top;
}

const cumulativeOffset = (element) => {
  let top = 0, left = 0;
  do {
    top += element.offsetTop  || 0;
    left += element.offsetLeft || 0;
    element = element.offsetParent;
  } while(element);

  return {
    top: top,
    left: left
  };
};

const scrollTimeout = 500;

export const ScrollSpy = () => ({
  "x-init"() {

    [...document.querySelectorAll(".in-page-navigation-point")].map(
      (item) => {
        const title = item.dataset.title;
        const id = item.id;

        this.$data.items.push({
          href: "#",
          title: title,
          id: id,
          ref: item,
        });
      }
    );

    addEventListener("scroll", (e) => {
      if (this.$data.ignoreScroll) return;

      let activeSet = false;
      [...this.$data.items].forEach((item, itemIndex) => {
        if (isElementScrolledPast(item.ref) && !activeSet) {
          this.activeIndex = itemIndex;
          activeSet = true;
        }
      });
    });

    this.$watch("goToIndex", val => {
      // Scroll to active header
      const activeHeader = [...this.items][val].ref;
      const itemTop = cumulativeOffset(activeHeader).top - (isMobileDisplay() ? getStickyMenuOffset() : 0);

      window.scrollTo({
        top: itemTop,
        behavior: "smooth",
        block: "start",
      });

      this.$data.activeIndex = val;
    });

    this.$watch("activeIndex", val => {
      const activeItem = [...this.items][val];
      this.$data.ignoreScroll = true;

      // setTimeout(() => , scrollTimeout)

      if (isMobileDisplay()) {
        const activeScrollItem = this.$el.querySelectorAll(`.${menuEl}__item`)[val];

        this.$el.scrollTo({
          left: activeScrollItem?.offsetLeft ? activeScrollItem?.offsetLeft : 0,
          behavior: "smooth",
        });
      }

      setTimeout(() => {
        history.pushState(activeItem.title, {}, `#${activeItem.id}`);
        this.$data.ignoreScroll = false;
    }, scrollTimeout);
    });
  },
});

export const ScrollSpyInit = () => {
  Alpine.bind('ScrollSpy', ScrollSpy);
}
